import { HorizontalRail } from "../../design-v2";

function isSameSelection(left, right) {
  return String(left) === String(right);
}

export default function WeekRail({
  weeks = [],
  selectedWeekNumber,
  onSelect,
  distribute = false,
}) {
  const weekCount = Math.max(1, weeks.length);
  const selectedWeekIndex = weeks.findIndex((week) =>
    isSameSelection(week.weekNumber, selectedWeekNumber)
  );
  const weekButtons = weeks.map((week) => {
    const isActive = isSameSelection(week.weekNumber, selectedWeekNumber);
    return (
      <button
        className={`lz-product-rail-button${isActive ? " lz-product-rail-button--active" : ""}`}
        type="button"
        key={week.id || week.weekNumber}
        data-rail-item={week.weekNumber}
        aria-label={`Week ${week.weekNumber}`}
        aria-current={isActive ? "true" : undefined}
        onClick={() => onSelect?.(week.weekNumber)}
      >
        W{week.weekNumber}
      </button>
    );
  });

  return (
    <HorizontalRail
      className={[
        "lz-product-rail lz-product-week-rail",
        distribute ? "lz-product-week-rail--distributed" : "",
      ].filter(Boolean).join(" ")}
      aria-label="Week selection"
      activeItem={selectedWeekNumber}
      snap="start"
      style={distribute ? { "--lz-product-week-count": weekCount } : undefined}
    >
      {distribute ? (
        <div
          className="lz-product-week-rail__track"
          style={{
            "--lz-product-week-pill-width": `${100 / weekCount}%`,
            "--lz-product-week-pill-offset": `${Math.max(0, selectedWeekIndex) * 100}%`,
            minWidth: `${weekCount * 44}px`,
          }}
        >
          {selectedWeekIndex >= 0 ? (
            <span className="lz-product-week-rail__pill" aria-hidden="true" />
          ) : null}
          {weekButtons}
        </div>
      ) : weekButtons}
    </HorizontalRail>
  );
}
